/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnalyticsDeviceType, AnalyticsInput } from '@web/graphql-types'
import { v4 as uuid } from 'uuid'
import { usePageStore } from '../libs/hooks/usePageStore'

declare global {
  interface Window {
    ga: any
    fbq: any
    _fbq: any
  }
}

const getUserAgent = () => navigator.userAgent
const getDeviceType = () => {
  const width = window.innerWidth
  if (width < 768) return AnalyticsDeviceType.Mobile
  if (width < 992) return AnalyticsDeviceType.Tablet
  return AnalyticsDeviceType.Desktop
}
const gaEnabled = () => typeof window?.ga === 'function'
const fbpEnabled = () => window?._fbq.queue.length === 0
export const generateOrGetDeviceUUID = () => {
  try {
    let deviceUUID = localStorage.getItem('deviceUUID')
    if (!deviceUUID) {
      deviceUUID = uuid()
      localStorage.setItem('deviceUUID', deviceUUID)
    }
    return deviceUUID
  } catch {
    return uuid()
  }
}

// Helper function to get a specific cookie by name
const getCookieValue = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()!.split(';').shift()
  return null
}

// Function to get fbp and fbc from cookies
export const getFacebookPixelCookies = () => {
  const fbp = getCookieValue('_fbp')
  const fbc = getCookieValue('_fbc')

  return { fbp, fbc }
}

export const getAnalytics = (pageEventId: string, pixelId: string, isConversionsApi: boolean): AnalyticsInput => {
  const deviceUUID = generateOrGetDeviceUUID()
  const { fbp, fbc } = getFacebookPixelCookies()
  const { pageId, campaignId, charityId, isLiveMode } = usePageStore.getState()
  return {
    userAgent: getUserAgent(),
    deviceType: getDeviceType(),
    deviceUUID,
    hasFbPixel: fbpEnabled(),
    hasGoogleAnalytics: gaEnabled(),
    isLocalStorageAllowed: deviceUUID !== null,
    fbp: fbp,
    fbc: fbc,
    campaignId: campaignId,
    pageId: pageId,
    charityId: charityId,
    isLiveMode: isLiveMode,
    donationPageUrl: window.location.href,
    pixelId: pixelId,
    eventId: pageEventId,
    isConversionsApi,
  }
}
